import { Reveal, SectionHeading } from "@/components/Reveal";
import { ScanSearch, SprayCan, FileCheck } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: ScanSearch,
    title: "Ispezione & Scansione",
    desc: "Prima del lavaggio, il drone esegue un rilevamento ad alta risoluzione dell'impianto per mappare sporco, depositi e anomalie delle celle.",
  },
  {
    n: "02",
    icon: SprayCan,
    title: "Pulizia ad Alta Precisione",
    desc: "Ugelli atomizzatori ed erogazione calibrata di acqua osmotizzata pura rimuovono guano, polveri sottili e smog senza graffiare i pannelli.",
  },
  {
    n: "03",
    icon: FileCheck,
    title: "Report Post-Lavaggio",
    desc: "Ricevi il certificato di avvenuta manutenzione con l'incremento stimato della resa energetica del tuo impianto.",
  },
];

export function HowItWorks() {
  return (
    <section id="come-funziona" className="py-24 sm:py-32 relative" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeading
          eyebrow="Come Funziona"
          title={
            <>
              Tre passaggi. <span className="fire-text">Nessun ponteggio.</span>
            </>
          }
          sub="Il drone decolla dal nostro furgone officina e completa l'intero intervento dall'alto: tu non devi fare nulla, se non goderti il risultato."
        />

        <div className="grid md:grid-cols-3 gap-6 mt-16">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.12}>
              <div
                className="card-glow relative bg-[#13141B] border border-white/10 rounded-3xl p-8 h-full overflow-hidden"
                data-testid={`how-step-card-${i}`}
              >
                <span className="font-display font-bold text-[7rem] leading-none absolute -top-6 -right-2 text-white/[0.04] select-none">
                  {s.n}
                </span>
                <div className="w-12 h-12 rounded-2xl fire-bg flex items-center justify-center mb-6">
                  <s.icon size={22} className="text-white" />
                </div>
                <p className="font-mono-adj text-[10px] uppercase tracking-[0.3em] text-orange-500 mb-2">Step {s.n}</p>
                <h3 className="font-heading text-xl sm:text-2xl font-bold text-white">{s.title}</h3>
                <p className="text-sm text-slate-400 leading-relaxed mt-3">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
